import { api } from './api-client';
import type { StagedImport } from './api-types';

/** Reads a file as base64 in chunks so large uploads do not blow the argument limit. */
async function toBase64(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';
  for (let offset = 0; offset < bytes.length; offset += 8192) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + 8192));
  }
  return btoa(binary);
}

export async function stageImport(conversationId: string, file: File): Promise<StagedImport> {
  return api.stageImport(conversationId, {
    filename: file.name,
    mediaType: file.type || 'application/octet-stream',
    dataBase64: await toBase64(file),
  });
}
